import { lazy, useContext } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ReportLoadedContext } from "../../-reportLoadedContext";

const OrgReport = lazy(async () => await import("../../../../views/OrgReport"));

const PDFOrgReport = () => {
  const onFinishedLoading = useContext(ReportLoadedContext);
  return <OrgReport onFinishedLoading={onFinishedLoading} isPDFView={true} />;
};

export const Route = createFileRoute("/pdf/report/organization/summary")({
  component: PDFOrgReport,
});
